<template>
  <div v-if="toolVisible">
    <div class="tslsClass onePictureDialog dy3dDialog">
      <div class="headerClass">
        <div class="headerTitle">
          <!-- <img  :src="require('@/assets/images/dlgTitle.png')"/> -->
          <span>Cesium工具集</span>
        </div>

        <div class="boxClose">
          <img :src="require('@/assets/images/poscloseIcon.png')" style="cursor: pointer;" @click="toolsClose()" />
        </div>
          <!-- <span @click="close()"><a-icon type="close" style="color: aliceblue;cursor: pointer;" /></span> -->
      </div>
      <img class="splitLine" :src="require('@/assets/images/splitlineIcon.png')"/>
      <div class="areaTools">
        <div class="action">
            <span>操作：</span>
            <a-button class="delBtn" type="primary" @click="removeAll">清除测量数据</a-button>
        </div>
        <div class="rowBtn">
          <a-row class="label" style="margin-bottom: 1%">
            <span>测量工具：</span>
          </a-row>
          <a-row style="margin-bottom:2%">
            <a-button class="toolBtn" type="primary" @click="measureLine">距离测量</a-button>
            <a-button class="toolBtn" type="primary" @click="measureHeight">三角测量</a-button>
            <a-button class="toolBtn" type="primary" @click="measureArea">面积测量</a-button>
          </a-row>
          <a-row style="margin-bottom:2%">
            <a-button class="toolBtn" type="primary" @click="getSurfaceArea">表面面积</a-button>
            <a-button class="toolBtn" type="primary" @click="measureAngle">角度测量</a-button>
            <a-button class="toolBtn" type="primary" @click="measureVolume">体积测量</a-button>
          </a-row>        
        </div>
        <div class="rowBtn">
          <a-row class="label" style="margin-bottom: 1%">
            <span>分析工具：</span>
          </a-row>
          <a-row style="margin-bottom:2%">
            <a-button class="toolBtn" type="primary" :disable="!isover" @click="SunshineAnalysis">阴影分析</a-button>
            <a-button class="toolBtn" type="primary" @click="skylineAnalysis">天际线分析</a-button>
            <a-button class="toolBtn" type="primary" @click="profileAnalysis">剖面分析</a-button>
          </a-row>
          <a-row style="margin-bottom:2%">
            <a-button class="toolBtn" type="primary" @click="viewAnalysis">视域分析</a-button>
            <a-button class="toolBtn" type="primary" @click="clippiingAnalysis">地形开挖</a-button>
            <a-button class="toolBtn" type="primary" @click="measureVolume">体积测量</a-button>
          </a-row>        
        </div>
        <div>
          <span v-if="!isover && isShadow">阴影分析结果：正在分析中....</span>
          <span v-if="isover && isShadow">阴影分析结果：分析完成</span>
          <div v-if="isover && isShadow">
            <div style="background:rgb(0,228,0);width:20px;height: 20px;"></div><span> 0.05 </span>
            <div style="background:rgb(256,256,0);width:20px;height: 20px;"></div><span>0.05-0.15</span>
            <div style="background:rgb(256,126,0);width:20px;height: 20px;"></div><span>0.15-0.25</span>
            <div style="background:rgb(256,0,0);width:20px;height: 20px;"></div><span>0.25-0.35</span>
            <div style="background:rgb(153,0,76);width:20px;height: 20px;"></div><span>0.35-0.5</span>
            <div style="background:rgb(126,0,35);width:20px;height: 20px;"></div><span>0.5-0.85</span>
          </div>
        </div>
     </div>
    </div>
    <div v-if="showEcharts" style="position:absolute;left:25%;width: 800px;height: 400px;bottom:2px;background:white;z-index:99" id="profile"></div>
  </div>
</template>

<script>
import * as kriging from "kriging.js";
import measureDistance from '@/package/3d/js/utils/cesiumTools/measureDistance'

let handler = null
let map
let distance1 = new measureDistance()

export default {
  name: 'CesiumTools',
  data() {
    return {
      toolVisible: false,
      isover:false,//日照分析是否分析完成
      isShadow:false,
      showEcharts:false,
    }
  },
  methods: {
    init(cmap) {
      map = cmap
      this.toolVisible = true
    },
    //创建点实体
    createPoint(position){
      const points = map.viewer.entities.add({
        position:position,
        point:{
          color:Cesium.Color.ORANGE,
          pixelSize:5,
          // heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
        }
      })
      return points
    },
    //根据点去绘制线
    drawLine(positions){
      let shape 
      shape = map.viewer.entities.add({
        polyline:{
          positions:positions,
          clampToGround:false,
          width:3
        }
      })
      return shape
    },
    //计算两点间的距离
    async getSpaceDistance(positions,terrainProvider,labelPt,floatingPoint,viewer){
      let distance = 0
      var i = positions.length - 2
      var point1Cartographic = Cesium.Cartographic.fromCartesian(positions[i])
      var point2Cartographic = Cesium.Cartographic.fromCartesian(positions[i+1])

      var geodesic = new Cesium.EllipsoidGeodesic()
      geodesic.setEndPoints(point1Cartographic,point2Cartographic)

      var s = geodesic.surfaceDistance; //get distance from the start to the end
      var cartoPts = [point1Cartographic]
      //这里的分段采样可以换成线性插值lerp
      for(var jj = 100;jj<s;jj+=100){//分段采样计算距离
        var cartoPt = geodesic.interpolateUsingSurfaceDistance(jj) //求地表连线上特定距离的点的坐标
        cartoPts.push(cartoPt)
      }
      cartoPts.push(point2Cartographic)
      //带有地形高度的点
      const updatedPositions = await Cesium.sampleTerrain(map.viewer.terrainProvider, 8, cartoPts);
      console.log(updatedPositions);
      for(var ii = 0;ii<updatedPositions.length - 1;ii++){
        var geoD = new Cesium.EllipsoidGeodesic()
        geoD.setEndPoints(updatedPositions[ii],updatedPositions[ii+1])
        var innderS = geoD.surfaceDistance;
        console.log(innderS);
        innderS = Math.sqrt(Math.pow(innderS,2)+Math.pow(updatedPositions[ii+1].height-updatedPositions[ii].height,2)) //计算贴地距离（带地形的）
        console.log(innderS);
        distance += innderS
      }

      if(distance != 0){
        let textDistance = distance.toFixed(2) + 'm'
        console.log(distance.toFixed(2));
        if(textDistance >= 1000){
          textDistance = (distance / 1000.0).toFixed(2) + 'km'
        }
        floatingPoint = viewer.entities.add({
          name:'贴地距离',
          position:labelPt,
          point:{
            pixelSize:5,
            color:Cesium.Color.RED,
            outlineColor:Cesium.Color.WHITE,
            outlineWidth:2
          },
          label:{
            text:textDistance,
            font:'18px sans-serif',
            fillColor:Cesium.Color.GOLD,
            style:Cesium.LabelStyle.FILL_AND_OUTLINE,
            outlineWidth:2,
            verticalOrigin:Cesium.VerticalOrigin.BOTTOM,
            pixelOffset:new Cesium.Cartesian2(20,-20)
          }
        }) 
      }     
    },
    //距离测量
    async measureLine(){
      if(handler){
        handler.destroy()
        handler = null
      }
      distance1.measure(handler, map)
      return
      console.log('距离测量');
      const terrainProvider = await Cesium.createWorldTerrainAsync();
      const that = this
      let activePositions = []
      let floatingPoint;
      let activeShape;
      let labelPt;
      let distance;
      handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
      handler.setInputAction(function (event) {        
        const ray = map.viewer.camera.getPickRay(event.position)
        const earthPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
        // if mouse is not over the globe, earthPosition will be undefined
        if(Cesium.defined(earthPosition)){
          if(activePositions.length === 0){
            floatingPoint = that.createPoint(earthPosition)
            activePositions.push(earthPosition) // current point push in 
            //dynamic drawing : false represents the value will change, and this value will be returned every time
            const dynamicPositions = new Cesium.CallbackProperty(function (params) {
              return activePositions;
            },false)
            activeShape = that.drawLine(dynamicPositions)
          }

          // 标签的位置，具体绘制在getSpaceDistance
          labelPt = activePositions[activePositions.length - 1]
          if(activePositions.length >= 2){
            that.getSpaceDistance(activePositions,terrainProvider,labelPt,floatingPoint,map.viewer)
          }
          
          activePositions.push(earthPosition)
          that.createPoint(earthPosition)
        }
        
      },Cesium.ScreenSpaceEventType.LEFT_CLICK)

      handler.setInputAction(function (event) {
        if(Cesium.defined(floatingPoint)){
          const ray = map.viewer.camera.getPickRay(event.endPosition)
          const newPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
          if(Cesium.defined(newPosition)){
            floatingPoint.position.setValue(newPosition)
            activePositions.pop()
            activePositions.push(newPosition)
          }
        }
      },Cesium.ScreenSpaceEventType.MOUSE_MOVE)

      handler.setInputAction(function (event) {
        activePositions.pop() // the last point pop
        that.drawLine(activePositions)
        map.viewer.entities.remove(floatingPoint) //point
        map.viewer.entities.remove(activeShape) //line
        floatingPoint = undefined
        activeShape = undefined
        activePositions = []
      },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
    },
    //三角测量
    measureHeight(){
      if(handler){
        handler.destroy()
        handler = null
      }
      const that = this
      let activePositions = []
      let firstPoint,endPoint
      let highPoint,lowPoint,midPoint
      let heightLabel,spaceLabel,horizenLabel
      let spaceDistance,horizenDistance,heightShape
      let floatingPoint
      handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
      handler.setInputAction(function (event) {
        const ray = map.viewer.camera.getPickRay(event.position)
        const position = map.viewer.scene.globe.pick(ray,map.viewer.scene)

        if(Cesium.defined(position)){
            var cartographic = Cesium.Cartographic.fromCartesian(position)
            var longitude = Cesium.Math.toDegrees(cartographic.longitude)
            var latitude = Cesium.Math.toDegrees(cartographic.latitude)
            var height = cartographic.height
            console.log(longitude,latitude,height);
            floatingPoint = map.viewer.entities.add({
              position:position,
              point:{
                color:Cesium.Color.ORANGE,
                pixelSize:5,
              }
            })
            if(!firstPoint){
              firstPoint = position.clone()
            }else{
              endPoint = position.clone()

              activePositions.pop() // the last point pop
              // that.drawLine(activePositions)
              map.viewer.entities.remove(floatingPoint) //point
              handler.destroy()
              handler = null
            }

            if(firstPoint && endPoint){
              const cartographic1 = Cesium.Cartographic.fromCartesian(firstPoint.clone())
              const cartographic2 = Cesium.Cartographic.fromCartesian(endPoint.clone())
              if(cartographic1.height > cartographic2.height){
                highPoint = firstPoint.clone()
                lowPoint = endPoint.clone()
                midPoint = Cesium.Cartesian3.fromRadians(cartographic2.longitude,cartographic2.latitude,cartographic1.height)
              }else{
                highPoint = endPoint.clone()
                lowPoint = firstPoint.clone()
                midPoint = Cesium.Cartesian3.fromRadians(cartographic1.longitude,cartographic1.latitude,cartographic2.height)
              }
            }

          activePositions.push(position)
          const dynamicPositions = new Cesium.CallbackProperty(function (params) {
            return [firstPoint,position]
          },false)
          spaceDistance = that.drawLine(dynamicPositions)
          if(firstPoint && endPoint && spaceDistance){
              let heightPoint = new Cesium.Cartesian3(activePositions[0].x,activePositions[0].y,position.z)
              const heightPositions = new Cesium.CallbackProperty(function (params) {
                return [lowPoint,midPoint]
              },false)
              heightShape = that.drawLine(heightPositions)

              heightLabel = Math.abs(Cesium.Cartographic.fromCartesian(highPoint).height - Cesium.Cartographic.fromCartesian(lowPoint).height).toFixed(2)
              let testHeight = Math.abs(highPoint.z - lowPoint.z)
              let height_mid = Cesium.Cartesian3.midpoint(lowPoint,midPoint,new Cesium.Cartesian3())
              map.viewer.entities.add({
                position:height_mid,
                label:{
                  text:'高度差：' + heightLabel + 'm',
                  font:'12px Helvetica',
                  fillColor:Cesium.Color.SKYBLUE,
                  outlineColor:Cesium.Color.YELLOW,
                  outlineWidth:2,
                  style:Cesium.LabelStyle.FILL_AND_OUTLINE,
                  verticalOrigin:Cesium.VerticalOrigin.CENTER,
                }
              })
              const horizenPositions = new Cesium.CallbackProperty(function (params) {
                return [highPoint,midPoint]
              },false)
              horizenDistance = that.drawLine(horizenPositions)
            }
          map.viewer.entities.add({
            position:position,
            point:{
              color:Cesium.Color.ORANGE,
              pixelSize:5,
            }
          })
          }          
      },Cesium.ScreenSpaceEventType.LEFT_CLICK)

      handler.setInputAction(function (event) {

        if(Cesium.defined(floatingPoint)){
          const ray = map.viewer.camera.getPickRay(event.endPosition)
          const position = map.viewer.scene.globe.pick(ray,map.viewer.scene)
          if(Cesium.defined(position)){

            let pickObj = map.viewer.scene.pick(event.endPosition)
            floatingPoint.position.setValue(position)
            endPoint = position.clone()
            activePositions.pop()
            activePositions.push(position)
          }
        }

      },Cesium.ScreenSpaceEventType.MOUSE_MOVE)
    },
    measureArea(){
      if(handler){
        handler.destroy()
        handler = null
      }
      const that = this
      handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
      let drawPoint,polygonShape
      let pointsCollection = [] //用于存储点集，以动态绘制面
      let tempPoints = [] //用于面积计算
      handler.setInputAction(function (event) {
        //屏幕选点
        let ray = map.viewer.camera.getPickRay(event.position)
        let earthPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
        //根据选定的坐标绘制点
        if(Cesium.defined(earthPosition)){
          if(pointsCollection.length === 0){
            drawPoint = that.createPoint(earthPosition)
            pointsCollection.push(earthPosition)
            const dynamicPositions = new Cesium.CallbackProperty(function (params) {
              return new Cesium.PolygonHierarchy(pointsCollection)
            },false)
            polygonShape = that.createPolygon(dynamicPositions)
          }
          pointsCollection.push(earthPosition)
          that.createPoint(earthPosition)
        }
        
      },Cesium.ScreenSpaceEventType.LEFT_CLICK)

      handler.setInputAction(function (event) {
        if(Cesium.defined(drawPoint)){
          const ray = map.viewer.camera.getPickRay(event.endPosition)
          const newPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
          if(Cesium.defined(newPosition)){
            drawPoint.position.setValue(newPosition)
            pointsCollection.pop()
            pointsCollection.push(newPosition)
          }
        }

      },Cesium.ScreenSpaceEventType.MOUSE_MOVE)

      handler.setInputAction(function (event) {
        pointsCollection.pop()
        that.createPolygon(pointsCollection)
        let textArea = that.getArea(pointsCollection)
        let res = 0
        let turfPoints = []
        let polygonPoints = pointsCollection
        polygonPoints.push(pointsCollection[0])
        for(let i = 0;i<pointsCollection.length;i++){
          const cartographic = Cesium.Cartographic.fromCartesian(pointsCollection[i])
          const longitude = Cesium.Math.toDegrees(cartographic.longitude)
          const latitude = Cesium.Math.toDegrees(cartographic.latitude)
          console.log(longitude,latitude);
          turfPoints.push([longitude,latitude])
        }

        let turfPolygon = turf.polygon([turfPoints])
        let turfArea = turf.area(turfPolygon)
        //多边形拆分成三角形，利用海伦公式计算面积
        let triangles,firstIndex,secondIndex,thirdIndex
        if(turfPoints.length == 4){
          triangles = [turfPolygon]
        }else{
          triangles = turf.tesselate(turfPolygon)
        }
        triangles.features.forEach(feature=>{
          console.log(feature);
          firstIndex = turfPoints.findIndex(item=>item.toString()==feature.geometry.coordinates[0][0].toString())
          secondIndex = turfPoints.findIndex(item=>item.toString()==feature.geometry.coordinates[0][1].toString())
          thirdIndex = turfPoints.findIndex(item=>item.toString()==feature.geometry.coordinates[0][2].toString())
          console.log(firstIndex,secondIndex,thirdIndex);

          let side1 = that.Distance(pointsCollection[firstIndex],pointsCollection[secondIndex])
          let side2 = that.Distance(pointsCollection[secondIndex],pointsCollection[thirdIndex])
          let side3 = that.Distance(pointsCollection[firstIndex],pointsCollection[thirdIndex])

          let p = (side1 + side2 + side3) / 2
          console.log('p',p);
          res += Math.sqrt(p * ((p-side1) * (p-side2) * (p-side3)))

        })
        if(res < 1000000.0){
          res = Math.abs(res).toFixed(4) + '平方米'
        }else{
          res = Math.abs((res / 1000000.0).toFixed(4)) + '平方公里'
        }
          console.log('面积',textArea,res,turfArea);
          map.viewer.entities.add({
            position:pointsCollection[pointsCollection.length - 1],
            label:{
              text:res,
              font:'18px sans-serif',
              fillColor:Cesium.Color.GOLD,
              style:Cesium.LabelStyle.FILL_AND_OUTLINE,
              outlineWidth:2
            }
          })
        map.viewer.entities.remove(drawPoint)
        map.viewer.entities.remove(polygonShape)
        drawPoint = null
        polygonShape = null
        pointsCollection = [] 
      },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
    },
    Distance(point1,point2){
      let point1Cartographic = Cesium.Cartographic.fromCartesian(point1)
      let point2Cartographic = Cesium.Cartographic.fromCartesian(point2)
      //根据经纬度计算距离
      let geodesic = new Cesium.EllipsoidGeodesic()
      geodesic.setEndPoints(point1Cartographic,point2Cartographic)
      let s = geodesic.surfaceDistance
      //返回两点之间的距离
      s = Math.sqrt(Math.pow(s,2) + Math.pow(point2Cartographic.height - point1Cartographic.height,2))
      return s
    },
    //绘制面
    createPolygon(positions){
      let shape
      shape = map.viewer.entities.add({
        positions:positions,
        polygon:{
          hierarchy:positions,
          material:Cesium.Color.YELLOW.withAlpha(0.5),
          outline:Cesium.Color.YELLOW
        }
      })
      return shape
    },
    //计算多边形面积
    getArea(points){
      let res = 0
      for(let i = 0;i<points.length - 2;i++){
        let j = (i % 1) % points.length
        let k = (i % 2) % points.length
        let totalAngle = this.Angle(points[i],points[j],points[k])
        // let dis_temp1 = this.Distance(points[j],points[0])
        // let dis_temp2 = this.Distance(points[k],points[0])
        let dis_temp1 = this.Distance(points[i],points[j])
        let dis_temp2 = this.Distance(points[j],points[k])
        res += dis_temp1 + dis_temp2 + Math.abs(Math.sin(totalAngle))
        console.log(dis_temp1,dis_temp2,totalAngle);
      }
      console.log('area',res);
      if(res < 1000000.0){
        res = Math.abs(res).toFixed(4) + '平方米'
      }else{
        res = Math.abs((res / 1000000.0).toFixed(4)) + '平方公里'
      }
      return res
    },
    Angle(p1,p2,p3){
      let bearing21 = this.Bearing(p2,p1)
      let bearing23 = this.Bearing(p2,p3)
      console.log('bearing',bearing21,bearing23);
      let angle = bearing21 - bearing23
      if(angle < 0){
        angle += 360
      }
      return angle
    },
    Bearing(from,to){
      from = Cesium.Cartographic.fromCartesian(from)
      to = Cesium.Cartographic.fromCartesian(to)
      console.log(from,to);

      let radiansPerDegree = Math.PI /180.0
      let degreesPerRadian = 180.0/Math.PI


      let lat1 = from.latitude * radiansPerDegree
      let lon1 = from.longitude * radiansPerDegree
      let lat2 = to.latitude * radiansPerDegree
      let lon2 = to.longitude * radiansPerDegree
      console.log('fromto',lat1,lon1,lat2,lon2);
      let angle = -Math.atan2(Math.sin(lon1-lon2) * Math.cos(lat2),Math.cos(lat1)*Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon1-lon2))
      if(angle < 0){
        angle += Math.PI * 2.0
      }
      angle = angle * degreesPerRadian;
      return angle
    },
    //测量表面面积
    getSurfaceArea(){
      if(handler){
        handler.destroy()
        handler = null
      }
      const that = this
      let pointsCollection = []
      let drawShape,drawPoint
      handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
      handler.setInputAction(function (event) {
        const ray = map.viewer.camera.getPickRay(event.position)
        const earthPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
        if(Cesium.defined(earthPosition)){
          if(pointsCollection.length === 0){
            drawPoint = that.createPoint(earthPosition)
            pointsCollection.push(earthPosition)
            const dynamicPositions = new Cesium.CallbackProperty(function (params) {
              return new Cesium.PolygonHierarchy(pointsCollection)
            },false)
            drawShape = that.createPolygon(dynamicPositions)
          }
          pointsCollection.push(earthPosition)
          drawPoint = that.createPoint(earthPosition)
        }
      },Cesium.ScreenSpaceEventType.LEFT_CLICK)

      handler.setInputAction(function (event) {
        if(Cesium.defined(drawPoint)){
          const ray = map.viewer.camera.getPickRay(event.endPosition)
          const newPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
          if(Cesium.defined(newPosition)){
            drawPoint.position.setValue(newPosition)
            pointsCollection.pop()
            pointsCollection.push(newPosition)
          }
        }
      },Cesium.ScreenSpaceEventType.MOUSE_MOVE)

      handler.setInputAction(function (event) {
        pointsCollection.pop()
        that.createPolygon(pointsCollection)
        that.computeSurfaceArea(pointsCollection)
        map.viewer.entities.remove(drawPoint)
        map.viewer.entities.remove(drawShape)
        
        drawPoint = null
        drawShape = null
        pointsCollection = []
      },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
    },
    //计算表面面积
    computeSurfaceArea(pointsCollection){
      //转换数组
      pointsCollection.push(pointsCollection[0])
      let transArr = []
      for(let i = 0;i<pointsCollection.length;i++){
        const cartographic = Cesium.Cartographic.fromCartesian(pointsCollection[i])
        const longitude = Cesium.Math.toDegrees(cartographic.longitude)
        const latitude = Cesium.Math.toDegrees(cartographic.latitude)
        transArr.push([longitude,latitude])
      }

      //计算边界框
      let line = turf.lineString(transArr)
      let box = turf.bbox(line)
      let polygon = turf.polygon([transArr])

      let featureArr = []
      transArr.forEach(item=>{
        let point = turf.point(item)
        featureArr.push(point)
      })

      let featureCollection = turf.featureCollection(featureArr)

      let voronoiPolygon = turf.voronoi(featureCollection,{bbox:box})
      
      let res = 0
      voronoiPolygon.features.forEach(item=>{
        const intersectPolygon = turf.intersect(polygon,item.geometry)
        const intersectPoints = turf.explode(intersectPolygon)
        let turfArea = turf.area(intersectPolygon)
        res += turfArea
        
      })
      console.log('表面面积',res);
      if(res < 1000000.0){
        res = Math.abs(res).toFixed(4) + '平方米'
      }else{
        res = Math.abs((res / 1000000.0).toFixed(4)) + '平方公里'
      }
      map.viewer.entities.add({
          position:pointsCollection[pointsCollection.length - 1],
          label:{
            text:res,
            font:'18px sans-serif',
            fillColor:Cesium.Color.GOLD,
            style:Cesium.LabelStyle.FILL_AND_OUTLINE,
            outlineWidth:2
          }
        })
      //根据经纬度获取多边形的范围
    },
    toolsClose() {
      this.removeAll()
      this.toolVisible = false
    },
    //测量角度
    measureAngle(){
      if(handler){
        handler.destroy()
        handler = null
      }
      const that = this
      let pointsCollection = []
      let drawPoint,drawLine 
      let firstPosition
      handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
      handler.setInputAction(function (event) {
        const ray = map.viewer.camera.getPickRay(event.position)
        const earthPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
        if(Cesium.defined(earthPosition)){          
          if(pointsCollection.length === 0){
            drawPoint = that.createPoint(earthPosition)
            pointsCollection.push(earthPosition)
            if(!firstPosition){
              firstPosition = earthPosition.clone()
            }
          }else{
            //绘制线（起始点一样，终止点不一样的）
            const dynamicPositions = new Cesium.CallbackProperty(function (params) {
              return [firstPosition,earthPosition]
            },false)
            // drawLine = that.drawLine(dynamicPositions)
            drawLine = that.drawLine(dynamicPositions)
          }

          pointsCollection.push(earthPosition)
          that.createPoint(earthPosition)
        }
      },Cesium.ScreenSpaceEventType.LEFT_CLICK)

      handler.setInputAction(function (event) {
        if(Cesium.defined(drawPoint)){
          const ray = map.viewer.camera.getPickRay(event.endPosition)
          const newPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
          if(Cesium.defined(newPosition)){
            drawPoint.position.setValue(newPosition)
            pointsCollection.pop()
            pointsCollection.push(newPosition)
            // if(!drawLine){
              // drawLine = that.drawLine([firstPosition,pointsCollection[1]])
            // }
          }
        }
      },Cesium.ScreenSpaceEventType.MOUSE_MOVE)

      handler.setInputAction(function (params) {
        pointsCollection.pop()
        that.drawLine([firstPosition,pointsCollection[1]])
        that.drawLine([firstPosition,pointsCollection[pointsCollection.length - 1]])
        let cartographic1 = Cesium.Cartographic.fromCartesian(firstPosition)
        let cartographic2 = Cesium.Cartographic.fromCartesian(pointsCollection[1])
        let cartographic3 = Cesium.Cartographic.fromCartesian(pointsCollection[pointsCollection.length - 1])
        let lon1 = Cesium.Math.toDegrees(cartographic1.longitude)
        let lat1 = Cesium.Math.toDegrees(cartographic1.latitude)
        let lon2 = Cesium.Math.toDegrees(cartographic2.longitude)
        let lat2 = Cesium.Math.toDegrees(cartographic2.latitude)
        let lat3 = Cesium.Math.toDegrees(cartographic3.latitude)
        let lon3 = Cesium.Math.toDegrees(cartographic3.longitude)
        console.log(lon1,lat1);
        // let angle = that.computedAngle(lon1,lat1,lon2,lat2)
        let angle = that.computedAngle(lon1,lat1,lon2,lat2,lon3,lat3)
        console.log('angle',angle);
        map.viewer.entities.add({
          position:pointsCollection[0],
          label:{
            text:'角度：' + angle.toFixed(2),
            font:'18px sans-serif',
            fillColor:Cesium.Color.GOLD,
            style:Cesium.LabelStyle.FILL_AND_OUTLINE,
            outlineWidth:2,
            verticalOrigin:Cesium.VerticalOrigin.BOTTOM,
            pixelOffset:new Cesium.Cartesian2(20,-20)
          }
        })

        map.viewer.entities.remove(drawPoint)
        map.viewer.entities.remove(drawLine)
        drawPoint = null
        drawLine = null        
        pointsCollection = []
        handler.destroy()
        handler = null
      },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
    },
    computedAngle(lon1,lat1,lon2,lat2,lon3,lat3){
      // 以下代码是计算方位角的代码 (方位角只需绘制一条直线)
      // //以1为原点建立局部坐标系（正东为x，正北为y，垂直于地为z） 局部坐标转为世界坐标
      // const localtoWorldMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(
      //   new Cesium.Cartesian3.fromDegrees(lon1,lat1)
      // )
      // //求逆矩阵
      // const worldtoLocalMatrix = Cesium.Matrix4.inverse(localtoWorldMatrix,new Cesium.Matrix4())

      // const localPositionA = Cesium.Matrix4.multiplyByPoint(worldtoLocalMatrix,new Cesium.Cartesian3.fromDegrees(lon1,lat1),new Cesium.Cartesian3())

      // //b点在局部坐标的位置
      // const localPositionB = Cesium.Matrix4.multiplyByPoint(worldtoLocalMatrix,new Cesium.Cartesian3.fromDegrees(lon2,lat2),new Cesium.Cartesian3())

      // let newPoint = Cesium.Cartesian3.subtract(localPositionB,localPositionA,new Cesium.Cartesian3())
      // newPoint = Cesium.Cartesian3.normalize(newPoint,new Cesium.Cartesian3())
      // const north = new Cesium.Cartesian3(0,1,0)
      // const arc_north = Cesium.Cartesian3.dot(north,newPoint)
      // //east用于判断与正北是否大于180度
      // const east = new Cesium.Cartesian3(1,0,0)
      // const arc_east = Cesium.Cartesian3.dot(east,newPoint)
      // const radians_north = Math.acos(arc_north)
      // let dg = Cesium.Math.toDegrees(radians_north)
      // if(arc_east < 0) dg = 360 - dg
      // return dg

      // 以下代码是计算夹角
        let bear_o = turf.rhumbBearing([lon1,lat1],[lon2,lat2])
        let bear_s = turf.rhumbBearing([lon1,lat1],[lon3,lat3])
        let bear
        if(bear_o < 0 && bear_s <0){
          if(bear_o < bear_s) bear = (-bear_s) - (-bear_o)
          if(bear_o > bear_s) bear = (-bear_o) - (-bear_s)
        }else if(bear_o > 0 && bear_s < 0){
          bear = bear_o + (-bear_s)
        }else if(bear_o < 0 && bear_s > 0){
          bear = bear_s + (-bear_o)
        }else if(bear_o > 0 && bear_s > 0){
          if(bear_o > bear_s) bear = bear_o - bear_s
          if(bear_o < bear_s) bear = bear_s - bear_o
        }

        if(bear > 180) bear = 360 - bear
        if(bear < 0) bear = -bear
        return bear
    },
    // 体积方量测量（实际上用的是填方挖方的方法）
    measureVolume(){
      if(handler){
        handler.destroy()
        handler = null
      }
      //1.绘制面
      const that = this
      let drawPoint,drawPolygon
      let pointsCollection = []
      let cartographicArr = []
      //测量的时候最好把深度检测打开
      map.viewer.scene.globe.depthTestAgainstTerrain = true
      handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
      handler.setInputAction(function (event) {
        const ray = map.viewer.camera.getPickRay(event.position)
        let earthPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
        const featurePick = map.viewer.scene.pick(event.position)
        let cartographic
        if(Cesium.defined(featurePick)){          
          let cartesian = map.viewer.scene.pickPosition(event.position)
          // cartographic = Cesium.Cartographic.fromCartesian(cartesian)
          if(cartesian){
            earthPosition = cartesian.clone()
          }   
        }
        if(Cesium.defined(earthPosition)){
          if(pointsCollection.length == 0){
            drawPoint = that.createPoint(earthPosition)
            pointsCollection.push(earthPosition)
            const dynamicPositions = new Cesium.CallbackProperty(function (params) {
              return new Cesium.PolygonHierarchy(pointsCollection)
            },false)
            drawPolygon = that.createPolygon(dynamicPositions)
            cartographic = Cesium.Cartographic.fromCartesian(earthPosition)
            cartographicArr.push(cartographic)  
          }          
          drawPoint = that.createPoint(earthPosition)
          pointsCollection.push(earthPosition)
          cartographic = Cesium.Cartographic.fromCartesian(earthPosition)
          cartographicArr.push(cartographic)
        }

      },Cesium.ScreenSpaceEventType.LEFT_CLICK)

      handler.setInputAction(function (event) {
        if(Cesium.defined(drawPoint)){
          const ray = map.viewer.camera.getPickRay(event.endPosition)
          let newPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
          const featurePick = map.viewer.scene.pick(event.endPosition)
          let cartographic
          if(Cesium.defined(featurePick)){          
            let cartesian = map.viewer.scene.pickPosition(event.endPosition)
            if(cartesian){
              newPosition = cartesian.clone()
            }
          }
          if(Cesium.defined(newPosition)){
            drawPoint.position.setValue(newPosition)
            pointsCollection.pop()
            cartographicArr.pop()
            cartographic = Cesium.Cartographic.fromCartesian(newPosition)
            pointsCollection.push(newPosition)
            cartographicArr.push(cartographic) 
          }
        }
      },Cesium.ScreenSpaceEventType.MOUSE_MOVE)

      handler.setInputAction(function (event) {
        pointsCollection.pop()
        cartographicArr.pop()
        that.createPolygon(pointsCollection)
        //2.将绘制面的所有点组成三角网
        if(cartographicArr[0]){
          that.polygonToTIN(cartographicArr,true)          
        }else{
          that.polygonToTIN(pointsCollection)
        }       

        map.viewer.entities.remove(drawPoint)
        map.viewer.entities.remove(drawPolygon)
        pointsCollection = []
        drawPoint = null
        drawPolygon = null
        cartographicArr = []

      },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
    },
    //将面转成三角网
    polygonToTIN(pointsArr, isCarto){
      let result = {}
      let newArr = []
      let coorArr = []
      let sumHeight = 0
      let sumArea = 0
      let sumVolume = 0
      let baseHeight = 0
      let minHeight = 15000
      let maxHeight = -15000
      for(let i = 0;i<pointsArr.length;i++){
        let cartographic = isCarto ? pointsArr[i] : Cesium.Cartographic.fromCartesian(pointsArr[i])
        let longitude = Cesium.Math.toDegrees(cartographic.longitude)
        let latitude =  Cesium.Math.toDegrees(cartographic.latitude)
        let position = new Cesium.Cartographic(cartographic.longitude,cartographic.latitude)
        let height = map.viewer.scene.sampleHeight(position)
        let point = turf.point([longitude,latitude])
        
        minHeight = Math.min(minHeight,height)
        maxHeight = Math.max(maxHeight,height)
        baseHeight = baseHeight === 0 ? minHeight :baseHeight
        console.log(baseHeight,minHeight,maxHeight,height);
        sumHeight += height
        coorArr.push([longitude,latitude])
        newArr.push(point)
      }

      let lineString = turf.lineString(coorArr)

      let bbox = turf.bbox(lineString)
      coorArr.push(coorArr[0])
      console.log(coorArr,bbox);
      let polygon = turf.polygon([coorArr])
      let featureCollection = turf.featureCollection(newArr)

      let tinPolygon = turf.tin(featureCollection,{bbox:bbox})
      tinPolygon.features.forEach(feature => {
        let coord = feature.geometry.coordinates[0]
        let cartographic1 = new Cesium.Cartographic.fromDegrees(coord[0][0],coord[0][1])
        let cartographic2 = new Cesium.Cartographic.fromDegrees(coord[1][0],coord[1][1])
        let cartographic3 = new Cesium.Cartographic.fromDegrees(coord[2][0],coord[2][1])
        let height1 = map.viewer.scene.sampleHeight(cartographic1)
        let height2 = map.viewer.scene.sampleHeight(cartographic2)
        let height3 = map.viewer.scene.sampleHeight(cartographic3)
        let height = (height1 - minHeight + height2 - minHeight + height3 - minHeight)/3
        const intersectPolygon = turf.intersect(polygon,feature.geometry)
        const intersectPoints = turf.explode(intersectPolygon)
        let turfArea = turf.area(intersectPolygon)
        sumArea += turfArea
        let vol = turfArea * height
        sumVolume += vol
      });

      // let avgHeight = (sumHeight - pointsArr.length * minHeight) / pointsArr.length
      let avgHeight = (sumHeight) / pointsArr.length
      
      let fillVolume = 0
      let cutVolume = 0
      //低于基准面，填方:基准面到墙底部之间缺少部分填平的体积
      if(baseHeight >= avgHeight){
        fillVolume += (baseHeight - avgHeight) * sumArea
      }else{
        //高于基准面，挖方:基准面到地表之间凸出部分挖掉的体积
        cutVolume += (avgHeight - baseHeight) * sumArea
      }
      let volume = avgHeight * sumArea
      map.viewer.entities.add({
        position: isCarto ? Cesium.Cartographic.toCartesian(pointsArr[0]) : pointsArr[0],
        label:{
          text:"体积:"+(sumVolume/10000.0).toFixed(2) + '万方',
          font:'18px sans-serif',
          fillColor:Cesium.Color.GOLD,
          style:Cesium.LabelStyle.FILL_AND_OUTLINE,
          outlineWidth:2,
          pixelOffset:new Cesium.Cartesian2(20,-20)
        }
      })
    },
    testKrign(){
      console.log(kriging);
    },
    SunshineAnalysis(){
      if(handler){
        handler.destroy()
        handler = null
      }
      this.isShadow = true
      let options = {
        start:'2023-10-23 07:00',
        end:'2023-10-23 12:00',
        interval:60,//min
        spacing:10,//m
        startHeight:0,//m
        endHeight:40 //m
      }
      const that = this
      let pointsCollection = []
      let drawPoint
      let polygonShape     
      
      handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
      handler.setInputAction(function (event) {
        const ray = map.viewer.camera.getPickRay(event.position)
        const earthPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
        if(Cesium.defined(earthPosition)){
          if(pointsCollection.length === 0){
            drawPoint = that.createPoint(earthPosition)
            pointsCollection.push(earthPosition)
            const dynamicPositions = new Cesium.CallbackProperty(function (params) {
              return new Cesium.PolygonHierarchy(pointsCollection)
            },false)
            polygonShape = that.createPolygon(dynamicPositions)
          }
          pointsCollection.push(earthPosition)
          that.createPoint(earthPosition)
          that.createPolygon(pointsCollection)
        }
      },Cesium.ScreenSpaceEventType.LEFT_CLICK)

      handler.setInputAction(function (event) {
        if(Cesium.defined(drawPoint)){
          const ray = map.viewer.camera.getPickRay(event.endPosition)
          const newPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
          if(Cesium.defined(newPosition)){
            drawPoint.position.setValue(newPosition)
            pointsCollection.pop()
            pointsCollection.push(newPosition)
          }
        }
      },Cesium.ScreenSpaceEventType.MOUSE_MOVE)

      handler.setInputAction(function (event) {
        that.createPolygon(pointsCollection)
        pointsCollection.pop()

        that.isover = false
        that.analysisPolygon(polygonShape,options)

        map.viewer.entities.remove(drawPoint)
        map.viewer.entities.remove(polygonShape)
        drawPoint = null
        handler.destroy()
        handler = null
      },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
    },
    analysisPolygon(entity,options){
      const that = this
      let startHeight = options.startHeight
      let spacing = options.spacing
      let pointss = this.getPoint(entity,spacing,startHeight,startHeight + 10)
      let beginDate = new Date(options.start)
      let endDate = new Date(options.end)
      let i = 0
      that.start(beginDate,endDate,pointss,options,i,entity)
    },
    start(beginDate,endDate,pointss,options,i,entity){
      const that = this
      let current = beginDate.getTime() + 1000 * 60 * options.interval * i
      let currentTime = new Date(current)
      if(currentTime > endDate){
        // handler.destroy()
        // handler = null
        that.createResult(pointss,entity)
      }else{
        this.getSunPosition(currentTime,async function (sunPosition) {
          for(let j = 0;j<pointss.length;j++){
            if(that.sunShine(pointss[j],sunPosition)){
              pointss[j].through++ //shadow
            }else{
              pointss[j].out++ //sunshine
            }
          }

          i++
          that.start(beginDate,endDate,pointss,options,i,entity)
          // console.log('分析',pointss);
        })
      }
    },
    getPoint(entity,spacing,startHeight,endHeight){
      let hierarchy = []
      let dx = entity.polygon.hierarchy.getValue().positions;
      for(let j = 0;j<dx.length;j++){
        let x = Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(dx[j]).longitude)
        // console.log(x,Cesium.Cartographic.fromCartesian(dx[j]));
        let y = Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(dx[j]).latitude)
        hierarchy.push(x)
        hierarchy.push(y)
      }
      let bottomPoints = this.getTheBottomPoint(hierarchy)
      
      let pointsInPolygon = this.scanningPolygon(bottomPoints,spacing,spacing,hierarchy)
      let pointss = []
      let frequency = (endHeight - startHeight)/spacing
      for(let n = 0;n<frequency;n++){
        for(let m = 0;m<pointsInPolygon.length;m++){
          let point = pointsInPolygon[m]
          let point1 = {
            lon:point.lon,
            lat:point.lat,
            height:startHeight + spacing * n,
            through:0,
            out:0,
            color:''
          }
          pointss.push(point1)
        }
      }
      return pointss
    },
    getTheBottomPoint(points){
      var minLat = 90;
      var minIndex = 0;
      let i
      for(i = 1;i<points.length;i+=2){
        minLat = minLat < points[i] ? minLat : points[i]
        if(minLat !== 90){
          minIndex = i
        }
      }
      return {
        lon:points[minIndex - 1],
        lat:points[minIndex]
      }
    },
    scanningPolygon(bottomPoint,dx,dy,area){      
      let points = []
      let minLon = 180, maxLon = -180, maxLat = -90
      let d_lon,d_lat
      let westPoint,eastPoint,centerPoint

      for(let i = 0;i<area.length;i+=2){
        maxLat = maxLat > area[i+1] ? maxLat : area[i+1]
        maxLon = maxLon > area[i] ? maxLon : area[i]
        minLon = minLon < area[i] ? minLon : area[i]
      }
      let point1 = this.getPositionFromA_D(bottomPoint.lat,bottomPoint.lon,dy,0)
      let point2 = this.getPositionFromA_D(bottomPoint.lat,bottomPoint.lon,dx,90)

      d_lon = point2[0] - bottomPoint.lon
      d_lat = point1[1] - bottomPoint.lat
      points.push({lon:bottomPoint.lon,lat:bottomPoint.lat})
      centerPoint = {lon:bottomPoint.lon,lat:bottomPoint.lat}
      for(centerPoint.lat += d_lat;centerPoint.lat <= maxLat;centerPoint.lat +=d_lat){
        westPoint = {lon:centerPoint.lon - d_lon,lat:centerPoint.lat}
        eastPoint = {lon:centerPoint.lon + d_lon,lat:centerPoint.lat}
        if(this.IsInPolygon(centerPoint.lon,centerPoint.lat,area)){
          points.push({lon:centerPoint.lon,lat:centerPoint.lat})
        }
        for(;westPoint.lon >= minLon;westPoint.lon -= d_lon){
          if(this.IsInPolygon(westPoint.lon,westPoint.lat,area)){
            points.push({lon:westPoint.lon,lat:westPoint.lat})
          }
        }
        for(;eastPoint.lon <= maxLon;eastPoint.lon += d_lon){
          if(this.IsInPolygon(eastPoint.lon,eastPoint.lat,area)){
            points.push({lon:eastPoint.lon,lat:eastPoint.lat})
          }
        }
      }
      return points
    },
    getPositionFromA_D(lat,lon,distance,angle){
      let Ea = 6378137.0 // 赤道半径
      let Eb = 6356725.0 //极半径
      let dx = distance * Math.sin(angle * Math.PI / 180.0)
      let dy = distance * Math.cos(angle * Math.PI / 180.0)
      let ec = Eb + (Ea - Eb) * (90.0 - lat) / 90.0
      let ed = ec * Math.cos(lat * Math.PI/180.0)
      let newLon = (dx / ed + lon * Math.PI / 180.0) * 180.0 / Math.PI
      let newLat = (dy / ec + lat * Math.PI / 180.0) * 180.0 / Math.PI
      return [newLon,newLat]
    },
    IsInPolygon(lon,lat,area){
      let IsIn = 0
      let dLon1,dLon2,dLat1,dLat2,dLon
      for(let i = 0;i<area.length - 2;i+=2){
        dLon1 = area[i]
        dLat1 = area[i+1]

        dLon2 = area[i+2]
        dLat2 = area[i+2]
        if(((lat >= dLat1) && (lat < dLat2)) || ((lat >= dLat2) && (lat < dLat1))){
          if(Math.abs(dLat1 - dLat2) > 0){
            dLon = dLon1 - ((dLon1 - dLon2) * (dLat1 - lat))/(dLat1 - dLat2)
            if(dLon <= lon){
              IsIn++
            }
          }
        }
      }
      if(IsIn % 2 !== 0){
        return true
      }
      return false
    },
    getSunPosition(time,callback){
      //设置当前时间
      const that = this
      this.setTimeNow(time)
      let interval = setInterval(() => {        
        let julianCurrenttime = Cesium.JulianDate.fromDate(time);
        let transforMatrix = Cesium.Transforms.computeTemeToPseudoFixedMatrix(julianCurrenttime)
        let sunPositionTest = Cesium.Simon1994PlanetaryPositions.computeSunPositionInEarthInertialFrame(julianCurrenttime)
        Cesium.Matrix3.multiplyByVector(transforMatrix,sunPositionTest,sunPositionTest)
        callback(sunPositionTest)
        if(that.isover){
          clearInterval(interval)
        }
      }, 1000);
    },
    sunShine(position,sunPosition){
      let _position = Cesium.Cartesian3.fromDegrees(position.lon,position.lat,position.height)
      return this.pickFromRay(_position,sunPosition)
    },
    pickFromRay(start,end){
      //计算射线的方向：
      let direction = Cesium.Cartesian3.normalize(Cesium.Cartesian3.subtract(end,start,new Cesium.Cartesian3()),new Cesium.Cartesian3())
      //建立射线
      let ray = new Cesium.Ray(start,direction)
      let result = map.viewer.scene.pickFromRay(ray,[]) //计算交互点，返回第一个
      let isShowders = false
      if(result && result.object){
        isShowders = true
      }
      return isShowders
    },
    setTimeNow(startTime){
      var date = new Cesium.JulianDate.fromDate(startTime)
      return map.viewer.clock.currentTime = Cesium.JulianDate.addHours(date,8,new Cesium.JulianDate())
    },
    createResult(points,entity){
      //计算边框：
      let entityPosition = entity.polygon.hierarchy.getValue().positions
      let lonMin = Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[0]).longitude)
      let latMin = Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[0]).latitude)
      let lonMax = Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[0]).longitude)
      let latMax = Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[0]).latitude)
      for(let i = 1;i<entityPosition.length;i++){
        lonMin = lonMin < Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[i]).longitude) ? lonMin : Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[i]).longitude)

        latMin = latMin < Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[i]).latitude) ? latMin : Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[i]).latitude)

        lonMax = lonMax < Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[i]).longitude) ? Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[i]).longitude) : lonMax
        latMax = latMax < Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[i]).latitude) ? Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(entityPosition[i]).latitude) : latMax
      }

      let newPointsblue = []
      let poiTemp = []
      let lngArr = []
      let latArr = []
      let valueArr = []
      let resultPoint = map.viewer.scene.primitives.add(new Cesium.PointPrimitiveCollection())
      let result = map.viewer.scene.primitives.add(new Cesium.PrimitiveCollection())
      for(let i = 0;i<points.length;i++){
        var point = points[i]
        var sta = points[i].through + points[i].out
        var bfb = points[i].out / sta
        var color = ""
        if(bfb >= 0.7){
          color = Cesium.Color.BLUE
        }else if(bfb < 0.7 && bfb >= 0.3){
          color = Cesium.Color.YELLOW
        }else if(bfb < 0.3){
          color = Cesium.Color.RED
        }
        let poi = {
          position:Cesium.Cartesian3.fromDegrees(point.lon,point.lat,point.height),
          color:color,
          id:`阴影率：${(1-bfb) * 100}`
        }

        let heatPoi = {
          lat:point.lat,
          lon:point.lon,
          value:(1-bfb)
        }

        lngArr.push(point.lon)
        latArr.push(point.lat)
        valueArr.push(heatPoi.value)
      }
      map.viewer.entities.remove(entity)
      map.viewer.entities.add({
        rectangle:{
          coordinates:Cesium.Rectangle.fromDegrees(lonMin,latMin,lonMax,latMax),
          material:new Cesium.ImageMaterialProperty({
            image:this.getColorRampSun(valueArr,lngArr,latArr,lonMin,latMin,lonMax,latMax),
            transparent:true
          })
        }
      })
      this.isover = true
    },
    getColorRampSun(valueArr,lngArr,latArr,lonMin,latMin,lonMax,latMax){
      const canvas = document.createElement('canvas')
      canvas.width = 100
      canvas.height = 100
      const ctx = canvas.getContext('2d')
      
      //  ** kriging插值
      let color = [
        "rgb(0, 228, 0)",
        "rgb(256, 256, 0)",
        "rgb(256, 126, 0)",
        "rgb(256, 0, 0)",
        "rgb(153, 0, 76)",
        "rgb(126, 0, 35)",
      ]
      let variogram = kriging.train(valueArr,lngArr,latArr,"exponential",0,100)
      let coords = [[[lonMin,latMin],[lonMin,latMax],[lonMax,latMax],[lonMax,latMin]]]
      let grid = kriging.grid(coords,variogram,(latMax - latMin) / 10)
      kriging.plot(canvas,grid,[lonMin,lonMax],[latMin,latMax],color)
   
      return canvas
    },
    //天际线分析（需要用到着色器后期处理）
    skylineAnalysis(){
      console.log(this.skylineAnayStages);
      if(this.skylineAnayStages){
        this.skylineAnayStages.enable = true //开启轮廓/后处理
        return
      }
      this.skylineAnayStages = map.viewer.scene.postProcessStages
      let edgeDetection = Cesium.PostProcessStageLibrary.createEdgeDetectionStage() //后处理的边缘检测
      let postProcessStages = new Cesium.PostProcessStage({
        //如果没有对name赋值，则会自动生成guid
        name:'skylinetem1',
        fragmentShader:`
          uniform sampler2D colorTexture; //颜色纹理
          uniform sampler2D depthTexture; //深度纹理
          in vec2 v_textureCoordinates;//纹理坐标
          out vec4 outColor;
          void main(void){
            float depth = czm_readDepth(depthTexture,v_textureCoordinates); //读取纹理坐标的深度值
            vec4 color = texture(colorTexture,v_textureCoordinates); //读取像素颜色
            // 如果不是边界，就保持原来的颜色；如果是边界，则赋新值。
            if(depth < 1.0 - 0.000001){
              //gl_FragColor = color;
              outColor = color;
            }else{
              //gl_FragColor = vec4(1.0,0.0,0.0,1.0);
              outColor = vec4(1.0,0.0,0.0,1.0);
            }
          }
        `
      })
      let postProcessStages1 = new Cesium.PostProcessStage({
        name:'skylinetemp2',
        fragmentShader:`
          uniform sampler2D colorTexture;//原本的颜色纹理
          uniform sampler2D redTexture;//红色纹理
          uniform sampler2D silhouetteTexture;//轮廓
          in vec2 v_textureCoordinates;
          out vec4 outColor;
          void main(void){
            vec4 redColor = texture(redTexture,v_textureCoordinates);
            vec4 silhouetteTexture = texture(silhouetteTexture,v_textureCoordinates);
            vec4 color = texture(colorTexture,v_textureCoordinates);
            //（texture.r表示的是深度）
            //如果有深度就按照原本的颜色绘制；如果没有深度，有轮廓就绘制轮廓，否则就绘制原本的颜色
            if(redColor.r == 1.0){
              //gl_FragColor = mix(color,vec4(5.0,0.0,0.0,1.0),silhouetteTexture.a);
              outColor = mix(color,vec4(5.0,0.0,0.0,1.0),silhouetteTexture.a);
            }else{
              //gl_FragColor = color;
              outColor = color;
            }
          }
        `,
        uniforms:{
          redTexture:postProcessStages.name,
          silhouetteTexture:edgeDetection.name
        }
      })

      this.silhouette = new Cesium.PostProcessStageComposite({
        stages:[edgeDetection,postProcessStages,postProcessStages1],//按顺序执行
        //是否执行每个后处理阶段，其中一个阶段的输入是前一个阶段的输出，否则每个包含阶段的输入是组合之前执行的阶段的输出
        inputPreviousStageTexture:false,//if true，每个阶段输入是场景渲染的输出纹理或之前执行阶段的输出纹理；if false,合成中每个阶段的输入纹理都是相同的
        uniforms:edgeDetection.uniforms //后处理阶段的uniform
      })
      this.skylineAnayStages.add(this.silhouette)
    },
    //剖面分析（需要用到地形高度采样）
    profileAnalysis(){
      if(handler){
        handler.destroy()
        handler = null
      }
      console.log('echarts',this.$echarts);
      const that = this
      let drawPoint
      let drawLine
      let pointsCollection = []
      handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
      // 先绘制线
      handler.setInputAction(function (event) {
        const ray = map.viewer.camera.getPickRay(event.position)
        const earthPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
        if(Cesium.defined(earthPosition)){
          if(pointsCollection.length == 0){
            drawPoint = that.createPoint(earthPosition)
            const dynamicPositions = new Cesium.CallbackProperty(function (params) {
              return pointsCollection
            },false)
            drawLine = that.drawLine(dynamicPositions)
            pointsCollection.push(earthPosition)
          }
          that.createPoint(earthPosition)
          pointsCollection.push(earthPosition)
        }
      },Cesium.ScreenSpaceEventType.LEFT_CLICK)

      handler.setInputAction(function (event) {
        if(Cesium.defined(drawPoint)){
          const ray = map.viewer.camera.getPickRay(event.endPosition)
          const newPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
          if(Cesium.defined(newPosition)){
            drawPoint.position.setValue(newPosition)
            pointsCollection.pop()
            pointsCollection.push(newPosition)
          }
        }
      },Cesium.ScreenSpaceEventType.MOUSE_MOVE)

      handler.setInputAction(function (event) {
        pointsCollection.pop()
        that.drawLine(pointsCollection)
        that.computeProfile(pointsCollection[0],pointsCollection[pointsCollection.length - 1])
        // console.log('profile',result);
        map.viewer.entities.remove(drawPoint)
        map.viewer.entities.remove(drawLine)
        drawPoint = null
        drawLine = null
        pointsCollection = []
        handler.destroy()
        handler = null
      },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
    },
    async computeProfile(start,end){
      let profile = {}
      profile.distance = 0
      profile.arrLX = [] //距离
      profile.points = [] //cartographic坐标
      profile.arrPoint = [] //经纬度坐标
      profile.arrHB = [] //高程
      // 横轴是距离，纵轴是高程
      //cartographic
      const cartographicS = new Cesium.Cartographic.fromCartesian(start)
      const cartographicE = new Cesium.Cartographic.fromCartesian(end)
      const degreeS = new Cesium.Math.toDegrees(cartographicS)
      const degreeE = new Cesium.Math.toDegrees(cartographicE)
      profile.arrLX.push(0)
      profile.points.push(cartographicS)
      profile.arrPoint.push(degreeS)
      profile.arrHB.push(cartographicS.height)
      var cartoArr = []
      cartoArr.push(cartographicS)

      let geodesic = new Cesium.EllipsoidGeodesic()
      geodesic.setEndPoints(cartographicS,cartographicE)

      let s = geodesic.surfaceDistance
      console.log(s);

      let count = 10 //采样间隔
      for(let i = count;i<s;i+=count){
        // console.log(1111);
        let cartoPt = geodesic.interpolateUsingSurfaceDistance(i)
        // console.log('cartopt',cartoPt);
        let degreePt = new Cesium.Math.toDegrees(cartoPt)
        cartoArr.push(cartoPt)
        profile.points.push(cartoPt)
        profile.arrPoint.push(degreePt)
      }
      cartoArr.push(cartographicE)
      // console.log('carto',cartoArr);
      const updatedPositions = await Cesium.sampleTerrain(map.viewer.terrainProvider,8,cartoArr)
      console.log('positiom',updatedPositions);
      for(let i = 0;i<updatedPositions.length-1;i++){
        let geoD = new Cesium.EllipsoidGeodesic()
        geoD.setEndPoints(updatedPositions[i],updatedPositions[i+1])
        let innerS = geoD.surfaceDistance
        innerS = Math.sqrt(Math.pow(innerS,2) + Math.pow(updatedPositions[i+1].height - updatedPositions[i].height,2))
        // console.log('distance',innerS);
        profile.distance += innerS
        console.log(profile.distance);
        profile.arrLX.push(profile.arrLX[i] + innerS)
        profile.arrHB.push(updatedPositions[i].height)
      }
      profile.points.push(cartographicE)
      // profile.arrLX.push(profile.arrLX[profile.arrLX.length-1] + innerS)
      profile.arrPoint.push(degreeE)
      profile.arrHB.push(cartographicE.height)
      console.log('profile',profile);
      this.showEcharts = true
      // console.log('show',this.showEcharts);
      // return profile
      this.$nextTick(()=>{
        this.profileEchartsInit(profile.arrLX,profile.arrHB)
      })
      
    },
    profileEchartsInit(distanceArr,heightArr){      
      this.$echarts.init(document.getElementById('profile')).setOption({
        xAxis: {
          type: 'category',
          data: distanceArr
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: heightArr,
            type: 'line'
          }
        ]
      })
    },
    //视域分析
    viewAnalysis(){
      if(handler){
        handler.destroy()
        handler = null
      }
      // 绘制一个点，在该点创建一个相机
      // 通过相机构建视锥体
      const fs = `
        #define USE_CUBE_MAP_SHADOW true
        uniform sampler2D colorTexture;
        uniform sampler2D depthTexture;
        in vec2 v_textureCoordinates;
        uniform mat4 camera_projection_matrix;
        uniform mat4 camera_view_matrix;
        uniform samplerCube shadowMap_textureCube; //立方体贴图
        uniform mat4 shadowMap_matrix;
        uniform vec4 shadowMap_lightPositionEC;
        uniform vec4 shadowMap_normalOffsetScaleDistanceMaxDistanceAndDarkness;
        uniform vec4 shadowMap_texelSizeDepthBiasAndNormalShadingSmooth;
        uniform float helsing_viewDistance; //可见范围
        uniform vec4 helsing_visibleAreaColor; //可见区域的颜色
        uniform vec4 helsing_invisibleAreaColor; //不可见区域的颜色
        out vec4 fragColor;
        struct zx_shadowParameters
        {
            vec3 texCoords;
            float depthBias;
            float depth;
            float nDotL;
            vec2 texelStepSize;
            float normalShadingSmooth;
            float darkness;
        };
        float czm_shadowVisibility(samplerCube shadowMap, zx_shadowParameters shadowParameters)
        {
            float depthBias = shadowParameters.depthBias;
            float depth = shadowParameters.depth;
            float nDotL = shadowParameters.nDotL;
            float normalShadingSmooth = shadowParameters.normalShadingSmooth;
            float darkness = shadowParameters.darkness;
            vec3 uvw = shadowParameters.texCoords;
            depth -= depthBias;
            float visibility = czm_shadowDepthCompare(shadowMap, uvw, depth);
            return czm_private_shadowVisibility(visibility, nDotL, normalShadingSmooth, darkness);
        }
        vec4 getPositionEC(){
            return czm_windowToEyeCoordinates(gl_FragCoord);
        }
        vec3 getNormalEC(){
            return vec3(1.);
        }
        vec4 toEye(in vec2 uv,in float depth){
            vec2 xy=vec2((uv.x*2.-1.),(uv.y*2.-1.));
            vec4 posInCamera=czm_inverseProjection*vec4(xy,depth,1.);
            posInCamera=posInCamera/posInCamera.w;
            return posInCamera;
        }
        vec3 pointProjectOnPlane(in vec3 planeNormal,in vec3 planeOrigin,in vec3 point){
            vec3 v01=point-planeOrigin;
            float d=dot(planeNormal,v01);
            return(point-planeNormal*d);
        }
        float getDepth(in vec4 depth){
            float z_window=czm_unpackDepth(depth);
            z_window=czm_reverseLogDepth(z_window);
            float n_range=czm_depthRange.near;
            float f_range=czm_depthRange.far;
            return(2.*z_window-n_range-f_range)/(f_range-n_range);
        }
        float shadow(in vec4 positionEC){
            vec3 normalEC=getNormalEC();
            zx_shadowParameters shadowParameters;
            shadowParameters.texelStepSize=shadowMap_texelSizeDepthBiasAndNormalShadingSmooth.xy;
            shadowParameters.depthBias=shadowMap_texelSizeDepthBiasAndNormalShadingSmooth.z;
            shadowParameters.normalShadingSmooth=shadowMap_texelSizeDepthBiasAndNormalShadingSmooth.w;
            shadowParameters.darkness=shadowMap_normalOffsetScaleDistanceMaxDistanceAndDarkness.w;
            vec3 directionEC=positionEC.xyz-shadowMap_lightPositionEC.xyz;
            float distance=length(directionEC);
            directionEC=normalize(directionEC);
            float radius=shadowMap_lightPositionEC.w;
            if(distance>radius)
            {
                return 2.0;
            }
            vec3 directionWC=czm_inverseViewRotation*directionEC;
            shadowParameters.depth=distance/radius-0.0003;
            shadowParameters.nDotL=clamp(dot(normalEC,-directionEC),0.,1.);
            shadowParameters.texCoords=directionWC;
            float visibility=czm_shadowVisibility(shadowMap_textureCube,shadowParameters);
            return visibility;
        }
        bool visible(in vec4 result)
        {
            result.x/=result.w;
            result.y/=result.w;
            result.z/=result.w;
            return result.x>=-1.&&result.x<=1.
            &&result.y>=-1.&&result.y<=1.
            &&result.z>=-1.&&result.z<=1.;
        }
        void main(){
            // 釉色 = 结构二维(颜色纹理, 纹理坐标)
            fragColor = texture(colorTexture, v_textureCoordinates);
            // 深度 = 获取深度(结构二维(深度纹理, 纹理坐标))
            float depth = getDepth(texture(depthTexture, v_textureCoordinates));
            // 视角 = (纹理坐标, 深度)
            vec4 viewPos = toEye(v_textureCoordinates, depth);
            // 世界坐标
            vec4 wordPos = czm_inverseView * viewPos;
            // 虚拟相机中坐标
            vec4 vcPos = camera_view_matrix * wordPos;
            float near = .001 * helsing_viewDistance;
            float dis = length(vcPos.xyz);
            if(dis > near && dis < helsing_viewDistance){
                // 透视投影
                vec4 posInEye = camera_projection_matrix * vcPos;
                // 可视区颜色
                // vec4 helsing_visibleAreaColor=vec4(0.,1.,0.,.5);
                // vec4 helsing_invisibleAreaColor=vec4(1.,0.,0.,.5);
                if(visible(posInEye)){
                    float vis = shadow(viewPos);
                    if(vis > 0.3){
                      fragColor = mix(fragColor,helsing_visibleAreaColor,.5);
                    } else{
                      fragColor = mix(fragColor,helsing_invisibleAreaColor,.5);
                    }
                }
            }
        }`
        // 
        const that = this
        let drawPoint
        let drawLine
        let pointsCollection = []
        handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
        handler.setInputAction(function (event) {
          const ray = map.viewer.camera.getPickRay(event.position)
          const earthPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
          if(Cesium.defined(earthPosition)){
            if(pointsCollection.length == 0){
              //观测点的位置
              that.viewPosition = earthPosition
              drawPoint = that.createPoint(earthPosition)
              const dynamicPositions = new Cesium.CallbackProperty(function (params) {
                return pointsCollection
              },false)
              drawLine = that.drawLine(dynamicPositions)
              pointsCollection.push(earthPosition)
            }
            that.createPoint(earthPosition)
            pointsCollection.push(earthPosition)
          }
        },Cesium.ScreenSpaceEventType.LEFT_CLICK)

        handler.setInputAction(function (event) {
          if(Cesium.defined(drawPoint)){
            const ray = map.viewer.camera.getPickRay(event.endPosition)
            const newPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
            if(Cesium.defined(newPosition)){
              drawPoint.position.setValue(newPosition)
              pointsCollection.pop()
              pointsCollection.push(newPosition)
            }
          }
        },Cesium.ScreenSpaceEventType.MOUSE_MOVE)

        handler.setInputAction(function (event) {
          pointsCollection.pop()
          that.drawLine(pointsCollection)
          //计算距离
          // that.computeDistance()
          //或者
          that.viewPositionEnd = pointsCollection[pointsCollection.length - 1]
          that.viewDistance = Cesium.Cartesian3.distance(that.viewPosition, that.viewPositionEnd);

          that.viewHeading = that.getHeading(that.viewPosition,that.viewPositionEnd)
          that.viewPitch = that.getPitch(that.viewPosition,that.viewPositionEnd)
          //创建相机
          that.createLightCamera()
          that.createShadowMap()
          that.createPostStage(fs)
          that.drawSketch()

          map.viewer.entities.remove(drawPoint)
          map.viewer.entities.remove(drawLine)
          drawPoint = null
          drawLine = null
          pointsCollection = []
          handler.destroy()
          handler = null
        },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
    },
    getHeading(fromPosition,toPosition){
      let finalPosition = new Cesium.Cartesian3()
      let matrix4 = Cesium.Transforms.eastNorthUpToFixedFrame(fromPosition)
      Cesium.Matrix4.inverse(matrix4,matrix4)
      Cesium.Matrix4.multiplyByPoint(matrix4,toPosition,finalPosition)
      Cesium.Cartesian3.normalize(finalPosition,finalPosition)
      return Cesium.Math.toDegrees(Math.atan2(finalPosition.x,finalPosition.y))
    },
    getPitch(fromPosition,toPosition){
      let finalPosition = new Cesium.Cartesian3()
      let matrix4 = Cesium.Transforms.eastNorthUpToFixedFrame(fromPosition)
      Cesium.Matrix4.inverse(matrix4,matrix4)
      Cesium.Matrix4.multiplyByPoint(matrix4,toPosition,finalPosition)
      Cesium.Cartesian3.normalize(finalPosition,finalPosition)
      return Cesium.Math.toDegrees(Math.asin(finalPosition.z))
    },
    //创建相机(viewPosition是观测点的位置,viewDistance是观测距离,horizontalViewAngle可视域水平角,verticalViewAngle可视域垂直角,viewHeading航向角,viewPitch俯仰角)
    createLightCamera(horizontalViewAngle,verticalViewAngle){
      console.log('创建相机');
      let defaultHr = 90.0
      let defaultVr = 60.0
      if(horizontalViewAngle){
        defaultHr = horizontalViewAngle
      }
      if(verticalViewAngle){
        defaultVr = verticalViewAngle
      }
      this.lightCamera = new Cesium.Camera(map.viewer.scene)
      this.lightCamera.position = this.viewPosition

      //相机的视锥体
      this.lightCamera.frustum.near = this.viewDistance * 0.001
      this.lightCamera.frustum.far = this.viewDistance

      const hr = Cesium.Math.toRadians(defaultHr)
      const vr = Cesium.Math.toRadians(defaultVr)
      //视锥的宽高比
      const aspectRatio = (this.viewDistance * Math.tan(hr/2) * 2) / (this.viewDistance * Math.tan(vr/2) * 2)
      //视野
      if(hr > vr){
        this.lightCamera.frustum.fov = hr
      }else{
        this.lightCamera.frustum.fov = vr
      }
      this.lightCamera.setView({
        destination:this.viewPosition,
        orientation:{
          heading:Cesium.Math.toRadians(this.viewHeading || 0),
          pitch:Cesium.Math.toRadians(this.viewPitch || 0),
          roll:0
        }
      })
    },
    //创建阴影贴图
    createShadowMap(){
      this.shadowMap = new Cesium.ShadowMap({
        context:map.viewer.scene.context,
        lightCamera:this.lightCamera,
        enabled:this.enabled,//是否启用
        isPointLight:true,//是否是点光源，点光源的阴影不用cascades
        pointLightRadius:this.viewDistance,//点光源的半径
        cascadesEnabled:false,//利用多个阴影贴图覆盖不同视锥体的部分
        size:this.size,//每个阴影贴图的宽高（像素）
        softShadows:this.softShadows,//是否启用柔和阴影
        normalOffset:false,//是否将法向偏移应用到阴影中
        fromLightSource:false,
      })
      map.viewer.scene.shadowMap = this.shadowMap
      console.log('深度纹理',this.shadowMap);
    },
    //创建postStage(fs是片元着色器)
    createPostStage(fs){
      const postStage = new Cesium.PostProcessStage({
        fragmentShader:fs,
        uniforms:{
          shadowMap_textureCube:()=>{
            this.shadowMap.update(Reflect.get(map.viewer.scene,"_frameState"))
            return Reflect.get(this.shadowMap,"_shadowMapTexture")
          },
          shadowMap_matrix:()=>{
            this.shadowMap.update(Reflect.get(map.viewer.scene,"_frameState"))
            return Reflect.get(this.shadowMap,"_shadowMapMatrix")
          },
          shadowMap_lightPositionEC:()=>{
            this.shadowMap.update(Reflect.get(map.viewer.scene,"_frameState"))
            return Reflect.get(this.shadowMap,"_lightPositionEC")
          },
          shadowMap_normalOffsetScaleDistanceMaxDistanceAndDarkness:()=>{
            this.shadowMap.update(Reflect.get(map.viewer.scene,"_frameState"))
            const bias = this.shadowMap._pointBias;
            return Cesium.Cartesian4.fromElements(
              bias.normalOffsetScale,
              this.shadowMap._distance,
              this.shadowMap.maximumDistance,
              0.0,
              new Cesium.Cartesian4()
            )
          },
          shadowMap_texelSizeDepthBiasAndNormalShadingSmooth:()=>{
            this.shadowMap.update(Reflect.get(map.viewer.scene,"_frameState"))
            const bias = this.shadowMap._pointBias
            const scratchTexelStepSize = new Cesium.Cartesian2()
            const texelStepSize = scratchTexelStepSize
            texelStepSize.x = 1.0 / this.shadowMap._textureSize.x
            texelStepSize.y = 1.0 / this.shadowMap._textureSize.y
            return Cesium.Cartesian4.fromElements(
              texelStepSize.x,
              texelStepSize.y,
              bias.depthBias,
              bias.normalShadingSmooth,
              new Cesium.Cartesian4()
            )
          },
          camera_projection_matrix:this.lightCamera.frustum.projectionMatrix,
          camera_view_matrix:this.lightCamera.viewMatrix,
          helsing_viewDistance:()=>{
            return this.viewDistance
          },
          helsing_visibleAreaColor:this.visibleAreaColor || Cesium.Color.GREEN,
          helsing_invisibleAreaColor:this.invisibleAreaColor || Cesium.Color.RED
        }
      })
      this.postStage = map.viewer.scene.postProcessStages.add(postStage)
    },
    //创建视网
    drawSketch(){
      let defaultHr = 90.0
      let defaultVr = 60.0

      this.sketch = map.viewer.entities.add({
        name:'sketch',
        position:this.viewPosition,
        orientation:Cesium.Transforms.headingPitchRollQuaternion(
          this.viewPosition,
          // Cesium.HeadingPitchRoll.fromDegrees(this.viewHeading - this.horizontalViewAngle,this.viewPitch,0.0)
          Cesium.HeadingPitchRoll.fromDegrees(this.viewHeading - defaultHr,this.viewPitch,0.0)
        ),
        ellipsoid:{
          radii:new Cesium.Cartesian3(this.viewDistance,this.viewDistance,this.viewDistance),
          // minimumClock:Cesium.Math.toRadians(-this.horizontalViewAngle / 2),
          minimumClock:Cesium.Math.toRadians(-defaultHr / 2),
          // maximumClock:Cesium.Math.toRadians(this.horizontalViewAngle / 2),
          maximumClock:Cesium.Math.toRadians(defaultHr / 2),
          
          // minimumCone:Cesium.Math.toRadians(this.verticalViewAngle + 7.75),
          minimumCone:Cesium.Math.toRadians(defaultVr + 7.75),
          // maximumCone:Cesium.Math.toRadians(180 - this.verticalViewAngle - 7.75),
          maximumCone:Cesium.Math.toRadians(180 - defaultVr - 7.75),
          fill:false,
          outline:true,
          subdivisions:256,
          stackPartitions:64,
          slicePartitions:64,
          outlineColor:Cesium.Color.YELLOWGREEN
        }
      })
    },
    //地形开挖
    clippiingAnalysis(){
      // map.viewer.scene.globe._surface._tileProvider._debug.wireframe =true
      map.viewer.scene.globe.depthTestAgainstTerrain = true
      const that = this
      let activeShape;
      let floatingPoint;
      this.activeShapePoints = []
      handler = new Cesium.ScreenSpaceEventHandler(map.viewer.canvas)
      handler.setInputAction(function (event) {
        //use "viewer.scene.globe.pick" instead of "viewer.camera.pickEllipsoid" so that we get correct point when mousing over terrain
        const ray = map.viewer.camera.getPickRay(event.position)
        const earthPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
        //earthPosition will be undefine if our mouse is not over the globe
        if(Cesium.defined(earthPosition)){
          console.log(that.activeShapePoints);
          if(that.activeShapePoints.length === 0){
            floatingPoint = that.createPoint(earthPosition)
            that.activeShapePoints.push(earthPosition)
            const dynamicPositions = new Cesium.CallbackProperty(function () {
              return new Cesium.PolygonHierarchy(that.activeShapePoints)
            },false)
            activeShape = that.createPolygon(dynamicPositions)
            console.log('11111',that.activeShapePoints);
          }
          that.activeShapePoints.push(earthPosition)
          
          that.createPoint(earthPosition)
        }
      },Cesium.ScreenSpaceEventType.LEFT_CLICK)

      handler.setInputAction(function (event) {
        if(Cesium.defined(floatingPoint)){
          const ray = map.viewer.camera.getPickRay(event.endPosition)
          const newPosition = map.viewer.scene.globe.pick(ray,map.viewer.scene)
          if(Cesium.defined(newPosition)){
            floatingPoint.position.setValue(newPosition)
            that.activeShapePoints.pop()
            that.activeShapePoints.push(newPosition)
          }
        }
      },Cesium.ScreenSpaceEventType.MOUSE_MOVE)

      handler.setInputAction(function (event) {
        that.activeShapePoints.pop()
        that.createPolygon(that.activeShapePoints)
        map.viewer.entities.remove(floatingPoint)
        map.viewer.entities.remove(activeShape)
        floatingPoint = undefined
        activeShape = undefined
        // activeShapePoints = []
        that.clippingPlane()
      },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)     

    },
    //clip
    clippingPlane(){
      this.activeShapePoints.pop()
      let isClockWise = this.isClockWise(this.activeShapePoints)
      console.log(isClockWise);
      if(!isClockWise){
        this.activeShapePoints = this.activeShapePoints.reverse()
      }
      console.log('activepoint',this.activeShapePoints);
      const globe = map.viewer.scene.globe
      let midpoint
      let clippingPlanes = []
      for(let i=0;i<this.activeShapePoints.length;++i){
        const nextIndex = (i + 1) % this.activeShapePoints.length;
        console.log(nextIndex);
        midpoint = Cesium.Cartesian3.add(this.activeShapePoints[i],this.activeShapePoints[nextIndex],new Cesium.Cartesian3())
        midpoint = Cesium.Cartesian3.multiplyByScalar(midpoint,0.5,midpoint)
        console.log(midpoint);

        const up = Cesium.Cartesian3.normalize(midpoint,new Cesium.Cartesian3())
        let right = Cesium.Cartesian3.subtract(this.activeShapePoints[nextIndex],midpoint,new Cesium.Cartesian3())
        console.log(right);
        right = Cesium.Cartesian3.normalize(right,right)

        let normal = Cesium.Cartesian3.cross(right,up,new Cesium.Cartesian3())
        normal = Cesium.Cartesian3.normalize(normal,normal)
        
        const originCenteredPlane = new Cesium.Plane(normal,0.0)
        const distance = Cesium.Plane.getPointDistance(originCenteredPlane,midpoint)
        console.log(normal,distance);
        clippingPlanes.push(new Cesium.ClippingPlane(normal,distance))
        console.log('clippingPlanes',clippingPlanes);


      }
      globe.depthTestAgainstTerrain = true
      globe.clippingPlanes = new Cesium.ClippingPlaneCollection({
        // modelMatrix:Cesium.Transforms.eastNorthUpToFixedFrame(midpoint),
        planes:clippingPlanes,
        edgeWidth:1.0,
        edgeColor:Cesium.Color.WHITE,
        enable:true
      })

      this.activeShapePoints.push(this.activeShapePoints[0])
      for(let i = 0;i<this.activeShapePoints.length - 1;i++){
        let degrees1Lon = Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(this.activeShapePoints[i]).longitude)
        let degrees1Lat = Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(this.activeShapePoints[i]).latitude)
        let degrees2Lon = Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(this.activeShapePoints[i+1]).longitude)
        let degrees2Lat = Cesium.Math.toDegrees(Cesium.Cartographic.fromCartesian(this.activeShapePoints[i+1]).latitude)
        console.log(degrees1Lon);
        this.calculateWall(degrees1Lon,degrees1Lat,degrees2Lon,degrees2Lat)
      }
      map.viewer.entities.add({
        polygon:{
          hierarchy:this.activeShapePoints,
          height:-100.0,
          extrudedHeight:-100.0 + 1,
          material:new Cesium.ImageMaterialProperty({
            image:'img/textures/poly-soil.jpg',
          })
        }
      })
    },
    //判断是否为凹凸多边形(>0 为逆时针，<0为顺时针)
    isClockWise(points){
      let dir = (points[1].x - points[0].x) * (points[2].y - points[1].y) - (points[1].y - points[0].y) * (points[2].x - points[1].x)
      return dir > 0
    },
    calculateWall(lng1,lat1,lng2,lat2){
      const that = this
      let wallJwd = []
      let positions = []
      let heightB = []
      var pointSum = 100
      var addXTT = Cesium.Math.lerp(lng1,lng2,1.0 / pointSum) - lng1
      var addYTT = Cesium.Math.lerp(lat1,lat2,1.0 / pointSum) - lat1
      wallJwd.push(lng1,lat1)
      let cartesian = Cesium.Cartesian3.fromDegrees(lng1,lat1)
      positions.push(Cesium.Cartographic.fromCartesian(cartesian))
      for(let i = 0;i<pointSum;i++){
        var longitude = lng1 + (i+1) * addXTT
        var latitude = lat1 + (i+1) * addYTT
        wallJwd.push(longitude,latitude)
        cartesian = Cesium.Cartesian3.fromDegrees(longitude,latitude)
        positions.push(Cesium.Cartographic.fromCartesian(cartesian))
      }
      wallJwd.push(lng2,lat2)
      cartesian = Cesium.Cartesian3.fromDegrees(lng2,lat2)
      positions.push(Cesium.Cartographic.fromCartesian(cartesian))
      console.log(positions);
      //获取高度
      this.getHeightFromLonLat(positions,data=>{
        if(data){
          console.log(data);
          let heightA = data
          for(let i = 0;i<heightA.length;i++){
            heightB.push(-100.0) //原位置的高度 - 开挖深度
          }
        map.viewer.entities.add({
          wall:{
            positions:Cesium.Cartesian3.fromDegreesArray(wallJwd),
            maximumHeights:heightA,
            minimumHeights:heightB,
            material:new Cesium.ImageMaterialProperty({
              image:'img/textures/poly-stone.jpg',
              repeat:Cesium.Cartesian2(1,1)
            })
          }
        })
        }
      })
    },
    async getHeightFromLonLat(positions,callback){
      let height = []
      const that = this
      if(map.viewer.terrainProvider){
        if(map.viewer.terrainProvider instanceof Cesium.EllipsoidTerrainProvider){
          positions.forEach(p=>{
            height.push(0)
          })
          // if(typeof callback === 'function'){
            callback(height)
          // }
        }else{
          const updatedPositions = await Cesium.sampleTerrainMostDetailed(map.viewer.terrainProvider,positions)
          updatedPositions.forEach(item=>{
            console.log(item);
            height.push(item.height) //采样的地面高度
          })
          // if(typeof callback === 'function'){
            callback(height)
          // }
        }
      }else{
        positions.forEach(p=>{
          height.push(map.viewer.scene.globe.getHeight(p))
        })
        // if(typeof callback === 'function'){
          callback(height)
        // }
      }
    },
    removeAll() {
      if(map){
        map.viewer.entities.removeAll()
        map.viewer.scene.shadowMap = new Cesium.ShadowMap({
          lightCamera:map.camera,
          context:map.viewer.scene.context
        })
        map.viewer.scene.postProcessStages.removeAll()
      }
      if(this.postStage){
        this.postStage = null
      }
      if(this.skylineAnayStages){
        this.skylineAnayStages = null
      }
    },
  },
}
</script>

<style lang="less" scoped>
.tslsClass{
  position: absolute;
    top: 45px;
    width: 500px;
    max-width: 500px;
    height: 670px;
    right: 10px;
    // padding: 0px 15px;
    border-radius: 4px;
    color: #ffffff;
    -webkit-box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
    box-shadow: 0 3px 14px rgba(128, 128, 128, 0.5);
    backdrop-filter: blur(15px);
    z-index: 999;
    .headerClass{
      position: relative;
    }
}
.areaTools {
        margin: 0 3%;
        .action {
          margin-bottom: 2%;
          display: flex;
          align-items: center;
        }
        span {
            font-size: 14px;
        }
        .toolBtn {
            width: 90px;
            border-color: transparent;
            font-size: 14px;
            margin-right: 10px;
            // box-shadow: inset 0px 0px 10px 0px #1661F6;
        }
        .delBtn {
            background: rgba(255, 90, 90, 0.2);
            color: #FF5A5A;
        }

        /deep/ .ant-divider-horizontal {
            //   margin: 8% 2% !important;
            width: 96%;
            min-width: 97%;
        }

        /deep/ .ant-divider {
            background: rgba(255, 255, 255, 0.1);
        }
    }
.rowBtn{
  background: rgba(255, 255, 255, 0.2);
  padding: 2%;
  /deep/ .ant-row {
    display: flex;
    justify-content: space-around;
  }
}
.row {
  margin-bottom: 30px;
  color: #fff;
}
.earth-tree-ct1 {
  /deep/.ant-drawer {
    top: 135px;
    height: calc(100% - 90px);
  }
}
.earth-details-popup {
  z-index: 1;
}
.fontcolor {
  color: #ffffff;
}

/**************** 一个简洁文本面板,中间竖直连线 ****************/
.marsGreenGradientPnl {
  width: 100px;
  text-align: center;
  background-image: linear-gradient(to right, #565d39, #00ffc3);
  position: absolute;
  left: -56px;
  bottom: 28px;
  cursor: default;
  padding: 5px;
  border: 1px solid #9c9944e8;
}

.marsGreenGradientPnl:hover {
  border: 1px solid rgb(9, 255, 0);
}

.marsGreenGradientPnl::before {
  position: absolute;
  content: '';
  left: 50%;
  bottom: -30px;
  height: 30px;
  border-left: 2px dashed #c5e22770;
}

.marsGreenGradientPnl-highlight {
  border: 2px solid yellow;
}

.marsGreenGradientPnl-highlight::before {
  border-left: 2px dashed yellow !important;
}

/deep/ .ant-btn-primary{
  border-color: transparent;
}

/deep/ .ant-select-selection {
    background-color: rgba(255,255,255,0.2);
    border: 0px solid #FFFFFF;
}
/deep/ .ant-checkbox-inner{
  background-color: transparent;
  border: 1px solid rgba(255,255,255,0.5);
}

/deep/.ant-select-selection__rendered{
  margin-left: 17px;
}
</style>
